import { ref, computed } from 'vue'
import { supabase } from '../supabase/client'
import type { Session, User } from '@supabase/supabase-js'

const user = ref<User | null>(null)
const session = ref<Session | null>(null)
const loading = ref(true)

const fetchSession = async () => {
  loading.value = true
  const { data, error } = await supabase.auth.getSession()
  if (error) {
    console.error('Erreur lors de la récupération de la session', error)
  } else {
    session.value = data.session
    user.value = data.session?.user ?? null
  }
  loading.value = false
}

// Appel immédiat pour initialiser au chargement
fetchSession()

supabase.auth.onAuthStateChange((_event, newSession) => {
  session.value = newSession
  user.value = newSession?.user ?? null
})

export const useUserSession = () => ({
  user,
  session,
  loading,
  isAuthenticated: computed(() => !!user.value),
  fetchSession
})
